export const SET_ID = 'SET_ID';
export const SET_STAFFID = 'SET_STAFFID';
export const SET_STAFFNAME = 'SET_STAFFNAME';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_DESIGNATION = 'SET_DESIGNATION';
export const SET_ROLE_PERMISSIONS = 'SET_ROLE_PERMISSIONS'; // ✅ new


export const setId = (id) => ({
  type: SET_ID,
  payload: id,
});
export const setStaffid = (staffid) => ({
  type: SET_STAFFID,
  payload: staffid,
});
export const setStaffname = (staffname) => ({
  type: SET_STAFFNAME,
  payload: staffname,
});
export const setEmail = (email) => ({
  type: SET_EMAIL,
  payload: email,
});
export const setDesignation = (designation) => ({
  type: SET_DESIGNATION,
  payload: designation,
});

// ✅ New action for setting role permissions
export const setRolePermissions = (roleName, permissions) => ({
  type: SET_ROLE_PERMISSIONS,
  payload: { roleName, permissions },
});
